"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Phase_1 = require("@/common/Phase");
exports.default = vue_1.default.extend({
    name: 'GameOverview',
    data() {
        return {};
    },
    props: {
        status: {
            type: String,
        },
        game: {
            type: Object,
        },
        id: {
            type: String,
        },
    },
    computed: {
        statusClass() {
            switch (this.status) {
                case 'loading':
                    return 'status-loading';
                case 'error':
                    return 'status-error';
                case 'done':
                    if (this.isRunning) {
                        return 'status-running';
                    }
                    else {
                        return 'status-finished';
                    }
                default:
                    return '';
            }
        },
        isRunning() {
            return this.game?.phase !== Phase_1.Phase.END;
        },
    },
});
